import { addValidationRule } from '@akihirotakamura/formsy-react'

addValidationRule('isLat', (values, value) => {
  if (!value || value === '') return true
  return value.match(/^-?\d{1,3}(.\d{1,})?$/) && value <= 90 && value >= -90
})
